export const roleProp = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
export const HAKRedirectURL = 'https://g1klub.hr/';